import React from 'react';
import { Link } from 'react-router-dom';
import { connect } from "react-redux";
import { css_file_to_url } from "../../helper/css-util";
import { is_uuid } from "../../../lib/uuid";
import { getRGB } from "../../../lib/color";
import './entity.scss';
import { is_development_mode } from "../../helper/execute-mode";

class WLFEntity extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      wlf: props.wlf
    };
  }

  renderEditButtons = () => {
    const { wlf, onEdit, onClone, onDelete } = this.props;
    const is_dev = is_development_mode(this.props.config);
    const can_delete = is_uuid(wlf.css.id) && is_dev;

    const url = "/super-admin/css-editor/" + wlf.clientInfo.id;

    if (!onEdit) {
      return null;
    }

    return (
      <div className="level-right edit-btns">
        <div className="level-item">
          <Link to={url} className='button is-text is-small'>EDIT</Link>
        </div>
        { is_dev && <div className="level-item">
          <a className='button is-text is-small' onClick={e => onClone(wlf.clientInfo.id)}>CLONE</a>
        </div> }
        { is_dev && <div className="level-item">
          <a className='button is-text is-small'
             onClick={e => can_delete ? onDelete(wlf.clientInfo.id) : null }
             disabled={!can_delete}>DELETE</a>
        </div> }
      </div>);
  };

  render() {
    const {wlf} = this.props;
    const logo_url = css_file_to_url(this.props.config, wlf.css.logo);
    const allColors = {};
    Object.keys(wlf.css.color).forEach(prop => {
      allColors[prop] = getRGB(wlf.css.color[prop]);
    })

    return (
      <div className='wlf-entity'>
        <div className='client-title'>
          <nav className="level">
            <div className="level-left">
              <div className="level-item">
                {wlf.clientInfo.name}
              </div>
            </div>
            { this.renderEditButtons() }
          </nav>
        </div>
        <div className='header-section'>
          <img className='logo' src={logo_url} alt='Logo'/>
        </div>

        <div className='top-panel' style={{background: allColors.top_panel_tint}}>
          <nav className="level">
            <div className="level-left">
              <div className="level-item-1 sign-on-panel" style={{background: allColors.sign_on_background}}>
                <div className='input-field-palceholder'>Username</div>
                <div className='input-field-palceholder'>Password</div>
                <div className="sign-on-btn" style={{background: allColors.sign_on_button}}>Sign On</div>
              </div>
              <div className="level-item-2">
                <div className='top-panel-text' style={{color: allColors.sign_on_panel_text}}>Sign On Panel text</div>
                <div className="start-invest-btn" style={{background: allColors.sign_on_button}}>Start Investing</div>
              </div>
            </div>
          </nav>
        </div>

        <div style={{
          padding: "0.2rem",
          background: allColors.banner_background,
          borderBottom: "1px solid white",
        }}>
          <p style={{ color: allColors.banner_text,}}>Banner Text</p>
        </div>

        <div style={{
          padding: "0.2rem",
          background: allColors.onboarding_banner_background,
          borderBottom: "1px solid white",
        }}>
          <p style={{color: allColors.onboarding_banner_text}}>Onboarding Banner Text</p>
        </div>

        { /* <div className='mid-panel' style={{background: allColors.mid_panel}}>
          <p className='mid-panel-top-text' style={{color: allColors.mid_panel_top_text}}>Mid Panel Top Text</p>
          <p className='mid-panel-lower-text' style={{color: allColors.mid_panel_lower_text}}>Lower Text</p>
          <div className="mid-panel-button" style={{background: allColors.sign_on_button}}>Start Investing</div>
        </div> */ }

        {/* Footer */}
        <div className='footer-section' style={{background: allColors.footer_background}}>
          <p className='footer-text' style={{color: allColors.footer_primary_text}}>Footer Text</p>
          <p className='footer-sec-text' style={{color: allColors.footer_secondary_text}}>Footer Secondory Text</p>
        </div>

      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    config: state.app.config,
  }
};

export default connect(mapStateToProps)(WLFEntity);
